<style>
[v-cloak] {display: none}

/* The switch - the box around the slider */
.unit-switch {
	position: relative;
	display: inline-block;
	width: 46px;
	height: 24px;
	margin-bottom: 0;
}

/* Hide default HTML checkbox */
.unit-switch input {
	opacity: 0;
	width: 0;
	height: 0;
}

/* The slider */
.unit-slider {
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: #00a3e0;/* #ccc */;
	-webkit-transition: .4s;
	transition: .4s;
}

.unit-slider:before {
	position: absolute;
	content: "";
	height: 17px;
	width: 17px;
	left: 4px;
	bottom: 4px;
	background-color: white;
	-webkit-transition: .4s;
	transition: .4s;
}

input:checked + .unit-slider {
	background-color: #00a3e0; /* #2196F3; */
}

input:focus + .unit-slider {
	box-shadow: 0 0 1px #2196F3;
}

input:checked + .unit-slider:before {
	-webkit-transform: translateX(20px);
	-ms-transform: translateX(20px);
	transform: translateX(20px);
}

/* Rounded sliders */
.unit-slider.round {
	border-radius: 24px;
	background-color: #00a3e0;
}

.unit-slider.round:before {
	border-radius: 50%;
}


</style>

<template>
    <div class="relative bg-white rounded-lg shadow dark:bg-gray-700 modal-content">
		<!-- Modal header -->
		<div class="modal-header flex flex-col lg:flex-row gap-2 lg:gap-0 lg:justify-between items-center  rounded-t border-b dark:border-gray-600">
			<img alt="test" src="/img/layout/logo-alfaromeo-calc3.png" class="modal-logo">
			<h3 class="text-lg lg:text-2xl text-white  dark:text-white uppercase">
                Kalkulace úvěru
            </h3>
			<img alt="essox" src="/img/layout/logo--essox.png" class="essox-logo">
            <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white closeb" data-modal-toggle="calculatorModal">
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
            </button>
		</div>


        <!-- Modal body -->
        <div class="p-4 lg:p-0 lg:px-6 lg:pt-6 modal-body">

			<div class="content flex flex-col items-center justify-center" v-cloak>

				<div class="calculator__top-line flex flex-col items-center">

					<div class="text-center calculator__car-name">

						<h3 class="text-center font-bold text-lg uppercase">
							{{ carTitle }}
						</h3>

						<span class="calculator__desc">
							{{ carSpec }}
						</span>

					</div>

					<div class="text-center">

						<span class="calculator__product-name">
							{{ getProductName() }}
						</span>

					</div>
				</div>

				<div class="calc-border">
					<div class="calculator__bottom-border">
					</div>
				</div>

				<form @submit.prevent="onSubmit()" class="form-horizontal w-full">

					<div class="sliders-prices w-full flex flex-col justify-center items-center mb-6 lg:mb-1">

						<div class="requirements flex flex-row items-center justify-between py-8">
							<div class="">
								<span class="uppercase font-bold text-black">Vaše požadavky</span>
							</div>
							<!-- Rounded switch -->
							<div class="" style="text-align: right;">
								%
								<label class="unit-switch">
									<input v-model="use_currency_unit" type="checkbox" >
									<span class="unit-slider round"></span>
								</label>
								Kč
							</div>
						</div>

						<div class="sliders flex flex-col justify-center items-center w-97 ml-0">
							<div v-if="use_currency_unit !== true" class="form-group akontace w-full py-4">

								<div class="">
									<h4 class="calculator__heading-slider lg:text-left">AKONTACE: <span> {{ down_payment_pct }} %</span></h4>
									<input type="range" :min="advance_payment_min_pct" :max="advance_payment_max_pct" v-model="down_payment_pct" :step="advance_payment_step_pct" class="calculator__slider slider w-100" id="down_payment_pct" ref="down_payment_pct" @input="formItemChanged">
								</div>

								<div class="percents flex flex-row justify-between px-6">
									<div class="calculator__value"> <span> {{ advance_payment_min_pct }} </span>%</div>
									<div class="calculator__value">  <span> {{ advance_payment_max_pct }} </span>%</div>
								</div>
							</div>

							<div v-if="use_currency_unit === true" class="form-group akontace w-full py-4">

								<div class="">
									<h4 class="calculator__heading-slider lg:text-left">AKONTACE: <span> {{ new Intl.NumberFormat('cs-CZ').format(parseFloat(down_payment_amount).toFixed(0)) }} Kč</span></h4>
									<input type="range" :min="advance_payment_min_amount" :max="advance_payment_max_amount" v-model="down_payment_amount" :step="advance_payment_step_amount" class="calculator__slider slider w-100" id="down_payment_amount" ref="down_payment_amount" @input="formItemChanged">
								</div>

								<div class="percents flex flex-row justify-between px-6">
									<div class="calculator__value"> <span>{{ new Intl.NumberFormat('cs-CZ').format(parseFloat(advance_payment_min_amount).toFixed(0)) }} Kč</span></div>
									<div class="calculator__value"> <span>{{ new Intl.NumberFormat('cs-CZ').format(parseFloat(advance_payment_max_amount).toFixed(0)) }} Kč</span></div>
								</div>
							</div>


							<div class="form-group doba-splaceni w-full py-4">

								<div class="doba-splaceni-info">
									<h4 class="calculator__heading-slider lg:text-left">Doba splácení <span> {{ months }} </span> měsíců</h4>
									<input type="range" :min="duration_min_month" :max="duration_max_month" v-model="months" :step="duration_step_month" class="slider calculator__slider w-100" id="months" ref="months" @input="formItemChanged">
									<div class="minmonth" placeholder="duration_min_month"> </div>
								</div>

								<div class="percents flex flex-row justify-between px-6">
									<div class="calculator__value"> <span> {{ duration_min_month }} </span> měsíců</div>
									<div class="calculator__value"> <span> {{ duration_max_month }} </span>  měsíců</div>
								</div>
							</div>
						</div>

						<div class="financing-offer flex flex-col justify-center lg:justify-start items-center w-full">
							<div class="finance-heading">
								<span class="calculator__heading text-center uppercase font-bold">Vaše nabídka financování</span>
							</div>

							<div class="calculator__box">

								<div class="calculator__box-inner">
									<span class="calculator__price-text"> Váš vůz již od &nbsp;</span>
									<div class="price-month">
										<span class="calculator__price"> {{ parsed_anuita }} Kč </span>
										<span class="calculator__price-text"> / měsíc</span>
									</div>
								</div>
							</div>
							<div class="details" v-if="isDiscounted">
								<div class="calculator__info w-auto" >

									<div class="detail-info">
										<div class="">Pořizovací cena vč. DPH:</div>
										<div class="">{{ parsed_base_amount }} Kč</div>
									</div>
									<div class="detail-info">
										<div class="">Bonus financování:</div>
										<div class="">{{ parsed_discount_amount }} Kč</div>
									</div>
									<div class="detail-info">
										<div class="">Pořizovací cena vč. DPH a bonusu:</div>
										<div class="">{{ parsed_total_amount }} Kč</div>
									</div>
									<div class="detail-info">
										<div class="">Výše úvěru:</div>
										<div class="">{{ parsed_loan_amount }} Kč</div>
									</div>
									<div class="detail-info">
										<div class="">Počet splátek:</div>
										<div class="">{{ parsed_months }}</div>
									</div>
									<div class="detail-info">
										<div class="">Měsíční splátka:</div>
										<div class="">{{ parsed_anuita }} Kč</div>
									</div>
								</div>

								<div class="calculator__info">
									<div class="detail-info">
										<div class="">Přímá platba:</div>
										<div class="">{{ parsed_advanced_payment_pct }} %</div>
									</div>
									<div class="detail-info">
										<div class="">Přímá platba:</div>
										<div class="">{{ parsed_advanced_payment_amount }} Kč</div>
									</div>
									<div class="detail-info">
										<div class="">Pevná úroková sazba (p.a.):</div>
										<div class="">{{ parsed_interest }} %</div>
									</div>
									<div class="detail-info">
										<div class="">RPSN:</div>
										<div class="">{{ parsed_rpsn }} %</div>
									</div>
									<div class="detail-info">
										<div class="">Celková splatná částka:</div>
										<div class="">{{ parsed_total_costs }} Kč</div>
									</div>
									<div class="detail-info">
										<div class="">Poplatek za sjednání smlouvy:</div>
										<div class="">{{ parsed_initialisation_fee_amount }} Kč</div>
									</div>
								</div>
							</div>

							<div class="details" v-if="!isDiscounted">
								<div class="calculator__info" >

									<div class="detail-info">
										<div class="">Pořizovací cena vč. DPH:</div>
										<div class="">{{ parsed_total_amount }} Kč</div>
									</div>
									<div class="detail-info">
										<div class="">Výše úvěru:</div>
										<div class="">{{ parsed_loan_amount }} Kč</div>
									</div>
									<div class="detail-info">
										<div class="">Počet splátek:</div>
										<div class="">{{ parsed_months }}</div>
									</div>
									<div class="detail-info">
										<div class="">Přímá platba:</div>
										<div class="">{{ parsed_advanced_payment_pct }} %</div>
									</div>
									<div class="detail-info">
										<div class="">Přímá platba:</div>
										<div class="">{{ parsed_advanced_payment_amount }} Kč</div>
									</div>

								</div>

								<div class="calculator__info">

									<div class="detail-info">
										<div class="">Měsíční splátka:</div>
										<div class="">{{ parsed_anuita }} Kč</div>
									</div>
									<div class="detail-info">
										<div class="">Pevná úroková sazba (p.a.):</div>
										<div class="">{{ parsed_interest }} %</div>
									</div>
									<div class="detail-info">
										<div class="">RPSN:</div>
										<div class="">{{ parsed_rpsn }} %</div>
									</div>
									<div class="detail-info">
										<div class="">Celková splatná částka:</div>
										<div class="">{{ parsed_total_costs }} Kč</div>
									</div>
									<div class="detail-info">
										<div class="">Poplatek za sjednání smlouvy:</div>
										<div class="">{{ parsed_initialisation_fee_amount }} Kč</div>
									</div>

								</div>
							</div>

						</div>

					</div>

				</form>



				<div class="buttons  pt-3 pb-3 lg:pb-0">

					<button class="btn btn-secondary btn-lg btnpdf" style="margin-left: 0px;" @click="getCalculationPdf('download')">
						<img src="/img/layout/pdfdownload.png">
						<span style="margin-left: 15px;"> STÁHNOUT PDF </span>
					</button>


					<button class="btn btn-secondary btn-lg btnprint" style="margin-left: 0px;" @click="getCalculationPdf('print')">
						<img src="/img/layout/print3.png?v=2">
						<span> TISK </span>
					</button>


					<button data-modal-toggle="calculatorModal" type="button" class="btn btn-secondary btn-lg btn-close">ZAVŘÍT</button>

				</div>

			</div>

		</div>

        <!-- Modal footer -->
        <div class="modal-footer flex items-center p-6 lg:py-2 lg:px-6 rounded-b border-t border-gray-200 dark:border-gray-600 text-xxs">
            <p style="white-space: pre-line;">{{ this.legal_lines }}</p>
            <!--
            <button data-modal-toggle="calculatorModal" type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">I accept</button>
            <button data-modal-toggle="calculatorModal" type="button" class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:ring-gray-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600">Decline</button>
            -->
        </div>
	</div>
</template>

<script>
import _ from 'lodash'

export default {
	mounted() {
		console.log('Calculator Component mounted.')
	},
	created: function () {
		this.fetchCalculatorConfiguration()
	},
	props: ['calculatorSlug', 'basePrice', 'calculatorCaption', 'carTitle', 'carSpec', 'carAge', 'carId', 'carModelId'],
	computed: {
		advance_payment_min_amount: function () {
			return this.totalPrice * (this.advance_payment_min_pct / 100)
			//return new Intl.NumberFormat('cs-CZ').format(amount) //.replace(/\D00/, '') , { style: 'currency', currency: 'CZK' }
		},
		advance_payment_max_amount: function () {
			return this.totalPrice * (this.advance_payment_max_pct / 100)
			//return new Intl.NumberFormat('cs-CZ').format(amount) // .replace(/\D00/, ''); , { style: 'currency', currency: 'CZK' }
		},
		advance_payment_step_amount: function () {
			// TODO: vypodet kroku pro Kc
			return 1000
			//return new Intl.NumberFormat('cs-CZ').format(amount)
		},
		totalPrice: function () {
			if(parseInt(this.carModelId) > 0 && parseInt(this.carModelId) === parseInt(this.new_car_extra_discount_model)) {
				if(parseInt(this.new_car_extra_discount) > 0) {
					return parseInt(this.basePrice) - parseInt(this.new_car_extra_discount);
				}
			}

			if(parseInt(this.new_car_discount) > 0) {
				return parseInt(this.basePrice) - parseInt(this.new_car_discount);
			}

			return parseInt(this.basePrice);
		},
		isDiscounted: function () {
			return parseInt(this.totalPrice) !== parseInt(this.basePrice);
		}
	},
	data: function() {
		return {
			storeRoute: '/calculator/getCalculatorCalculation',
			configRoute: '/calculator/getCalculatorConfiguration',
			pdfRoute: '/calculator/getCalculatorCalculationPdf',
			//calculator: '3cf037d6f045e7605739858169432b0f',
			calculatorConfiguration: {},
			currentConfiguration: {},
			//monthsAndInterests: {},
			loan_amount: 0,
			// TODO: solve advance_payment vs. down_payment !!! both, client and server side
			down_payment_pct: 0,
			down_payment_amount: 0,
			advance_payment_max_pct: 0,
			advance_payment_min_pct: 0,
			advance_payment_step_pct: 0,
			duration_max_month: 36,
			duration_min_month: 6,
			duration_step_month: 1,
			interest: 0,
			months: 0,
			result: {},
			use_currency_unit: false,
			//
			initialisation_fee_calculation_method: '',
			initialisation_fee_value: 0.0,
			initialisation_fee_amount: 0,
			//
			legal_lines: '',
			//
			parsed_total_amount: '',
			parsed_base_amount: '',
			parsed_discount_amount: '',
			parsed_loan_amount_pct: '',
			parsed_advanced_payment_amount: '',
			parsed_advanced_payment_pct: '??',
			parsed_loan_amount: '',
			parsed_months: '',
			parsed_anuita: '',
			parsed_interest: '',
			parsed_rpsn: '',
			parsed_overpay: '',
			parsed_total_costs: '',
			parsed_initialisation_fee_amount: '',

			parsed_parsedResult: '<h2>Vlevo nastavte parametry a odešlete je prosím.</h2>',
			//
			new_car_discount: 0,
			new_car_extra_discount: 0,
			new_car_extra_discount_model: 0
		}
	},
	watch: {
		use_currency_unit: function () {
			this.resetToDefaults()
		}
	},
	methods: {
		resetToDefaults: function () {
			//this.setUpInitialValues();
			//this.monthsChanged();
			this.downPaymentChanged();
			this.onSubmit();
		},
		onSubmit: function () {
			let payment_pct

			if (this.use_currency_unit !== true) {
				payment_pct = this.down_payment_pct
			} else {
				payment_pct = 100 - ((this.totalPrice - this.down_payment_amount) / (this.totalPrice / 100))
			}

			axios.post(this.storeRoute, {
				calculator: this.calculatorSlug,
				total_amount: this.totalPrice,
				// TODO: solve advance_payment vs. down_payment !!! both, client and server side
				down_payment_pct: payment_pct,
				interest: this.interest,
				months: this.months,
				initial_fee: this.initialisation_fee_amount
			}).then(result => {
				this.result = result.data;
				this.parseResult();
			});
		},
		fetchCalculatorConfiguration() {
			axios.get(this.configRoute + '?calculator=' + this.calculatorSlug + '&car_age=' + this.carAge).then(result => {
				this.calculatorConfiguration = result.data;
				this.currentConfiguration = this.calculatorConfiguration.configuration;
				//this.monthsAndInterests = this.currentConfiguration.interests;
				this.interest = this.currentConfiguration.interest.replace(/,/g, '.');
				//this.interest = parseFloat(this.currentConfiguration.interest.replace(/,/g, '.')).toFixed(3);
				this.setUpInitialValues();
				this.monthsChanged();
				this.downPaymentChanged();
				this.onSubmit();
			});
		},
		getInitialisationFeeCalculationMethod() {
			//
			if(this.currentConfiguration.initialisation_fee_calculation_method) {
				return this.currentConfiguration.initialisation_fee_calculation_method;
			}

			return '';
		},
		getInitialisationFeeValue() {
			//
			if(this.currentConfiguration.initialisation_fee) {
				return parseFloat(this.currentConfiguration.initialisation_fee);
			}

			return 0.0;
		},
		getInitialisationFeeAmount() {
			//
			switch (this.initialisation_fee_calculation_method) {
				case "fixed":
					this.initialisation_fee_amount = this.getInitialisationFeeValue();
					break
				case "car-price-pct":
					this.initialisation_fee_amount = this.totalPrice * (this.getInitialisationFeeValue() * 0.01);
					break
				case "loan-price-pct":
					this.initialisation_fee_amount = this.this.loan_amount * (this.getInitialisationFeeValue() * 0.01);
					break
				default:
					this.initialisation_fee_amount = 0;
			}

			return this.initialisation_fee_amount;
		},
		setUpInitialValues() {
			this.down_payment_pct = this.getDefaultAdvancePaymentPct();
			this.months = this.getDefaultDurationMonth();
			this.duration_min_month = parseInt(this.currentConfiguration.duration_min_month);
			this.duration_max_month = parseInt(this.currentConfiguration.duration_max_month);
			this.duration_step_month = parseInt(this.currentConfiguration.duration_step_month);

			this.advance_payment_max_pct = parseInt(this.currentConfiguration.advance_payment_max_pct);
			this.advance_payment_min_pct = parseInt(this.currentConfiguration.advance_payment_min_pct);
			this.advance_payment_step_pct = parseInt(this.currentConfiguration.advance_payment_step_pct);

			this.new_car_discount = parseInt(this.currentConfiguration.new_car_discount);
			this.new_car_extra_discount = parseInt(this.currentConfiguration.new_car_extra_discount);
			this.new_car_extra_discount_model = parseInt(this.currentConfiguration.new_car_extra_discount_model);

			this.initialisation_fee_calculation_method = this.getInitialisationFeeCalculationMethod();
			this.initialisation_fee_value = this.getInitialisationFeeValue();
			this.initialisation_fee_amount = this.getInitialisationFeeAmount();

			this.legal_lines = this.currentConfiguration.legal_lines;
		},
		getDefaultAdvancePaymentPct() {
			/*
			if(Array.isArray(this.currentConfiguration.defaults)) {

				var obj;
				for(obj of this.currentConfiguration.defaults) {
					if(obj.car_age_min < this.carAge && obj.car_age_max > this.carAge) {
						console.log('for car ' + this.carTitle
								+ ' of age ' +  this.carAge
								+ ' is default advance_payment_pct: ' + obj.advance_payment_pct);
						return parseInt(obj.advance_payment_pct);
					}
				}


			}
			*/
			if(this.currentConfiguration.advance_payment_default_pct) {
				return parseInt(this.currentConfiguration.advance_payment_default_pct);
			}

			return parseInt(this.currentConfiguration.advance_payment_max_pct);

		},
		getDefaultDurationMonth() {
			/*
			if(Array.isArray(this.currentConfiguration.defaults)) {

				var obj;
				for(obj of this.currentConfiguration.defaults) {
					if(obj.car_age_min < this.carAge && obj.car_age_max > this.carAge) {
						console.log('for car ' + this.carTitle
								+ ' of age ' +  this.carAge
								+ ' is default duration_month: ' + obj.duration_month);
						return parseInt(obj.duration_month);
					}
				}


			}
			*/
			if(this.currentConfiguration.duration_default_month) {
				return parseInt(this.currentConfiguration.duration_default_month);
			}
			return parseInt(this.currentConfiguration.duration_max_month);

		},
		monthsChanged() {
			// we don't need to update interest, it's fixed now
			//this.interest = parseFloat(this.monthsAndInterests[this.months]).toFixed(2);
		},
		downPaymentChanged() {

			if (this.use_currency_unit !== true) {
				this.loan_amount = this.totalPrice - parseInt(this.totalPrice * (this.down_payment_pct / 100));
				this.down_payment_amount = parseInt(this.totalPrice * (this.down_payment_pct / 100));
			} else {
				this.loan_amount = this.totalPrice - this.down_payment_amount
			}

		},
		totalAmountChanged() {
			// nothing to do, yet
		},
		formItemChanged: _.debounce( function() {
			this.totalAmountChanged();
			this.downPaymentChanged();
			this.monthsChanged();
			this.onSubmit();
		}, 400),
        /*
        formItemChanged() {
            this.totalAmountChanged();
            this.downPaymentChanged();
            this.monthsChanged();
            this.onSubmit();
        },
        */
		parseResult() {
			this.parsed_total_amount = new Intl.NumberFormat('cs-CZ').format(parseFloat(this.result.total_amount).toFixed(0)) //.replace(/,00/, '');parseFloat(this.result.total_amount).toFixed(0)
			this.parsed_loan_amount_pct = new Intl.NumberFormat('cs-CZ').format(parseFloat(this.result.loan_amount_pct).toFixed(0)) //parseFloat(this.result.loan_amount_pct).toFixed(0)
			this.parsed_loan_amount = new Intl.NumberFormat('cs-CZ').format(parseFloat(this.result.loan_amount).toFixed(0)) //.replace(/\D00/, ''); //parseFloat(this.result.loan_amount).toFixed(0)
			if (this.use_currency_unit !== true) {
				this.parsed_advanced_payment_amount = new Intl.NumberFormat('cs-CZ').format(parseFloat(this.result.total_amount - this.result.loan_amount).toFixed(0)) //.replace(/\D00/, ''); parseFloat(this.result.total_amount - this.result.loan_amount).toFixed(0)
			} else {
				this.parsed_advanced_payment_amount = new Intl.NumberFormat('cs-CZ').format(parseFloat(this.down_payment_amount).toFixed(0)) //parseFloat(this.down_payment_amount).toFixed(0)
			}

			this.parsed_advanced_payment_pct = new Intl.NumberFormat('cs-CZ').format(parseFloat(this.result.loan_amount_pct).toFixed(0)); //new Intl.NumberFormat('cs-CZ').format(parseFloat(this.result.loan_amount_pct).toFixed(0))
			this.parsed_months = this.result.months;
			this.parsed_anuita = new Intl.NumberFormat('cs-CZ').format(this.result.anuita)
			this.parsed_interest = new Intl.NumberFormat('cs-CZ', { style: 'decimal' }).format(parseFloat(this.result.interest).toFixed(2));
			this.parsed_rpsn =  new Intl.NumberFormat('cs-CZ', { style: 'decimal' }).format(parseFloat(this.result.rpsn).toFixed(2));
			this.parsed_total_costs = new Intl.NumberFormat('cs-CZ').format(this.result.overpay + this.result.loan_amount) //.replace(/\D00/, ''); , { style: 'currency', currency: 'CZK' }

			this.parsed_base_amount = new Intl.NumberFormat('cs-CZ').format(parseFloat(this.basePrice).toFixed(0));
			this.parsed_discount_amount = new Intl.NumberFormat('cs-CZ').format(parseFloat(this.basePrice - this.totalPrice).toFixed(0));

			this.parsed_initialisation_fee_amount = new Intl.NumberFormat('cs-CZ').format(parseFloat(this.getInitialisationFeeAmount()).toFixed(0));
		},
		getCalculationPdf: function (action) {
			let payment_pct

			if(action === 'download') {
				this.$gtag.event('calculator-pdf-download-activated', { method: 'click' })
			} else {
				this.$gtag.event('calculator-pdf-print-activated', { method: 'click' })
			}

			if (this.use_currency_unit !== true) {
				payment_pct = this.down_payment_pct
			} else {
				payment_pct = 100 - ((this.totalPrice - this.down_payment_amount) / (this.totalPrice / 100))
			}
			axios.post(this.pdfRoute,
				{
					calculator: this.calculatorSlug,
					total_amount: this.totalPrice,
					// TODO: solve advance_payment vs. down_payment !!! both, client and server side
					down_payment_pct: payment_pct,
					interest: this.interest,
					months: this.months,
					car_id: this.carId,
					initial_fee: this.initialisation_fee_amount
				},
				{
					responseType: 'arraybuffer',
					headers: {
						Accept: 'application/pdf',
					}
				}
			).then(response => {
				//this.result = result.data;
				//this.parseResult();
				let blob = new Blob([response.data],{ type:'application/pdf'});
				let link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.target = "_blank";
				if(action == 'download') {
					link.download = "Peugeot_kalkulace_" + this.result.anuita + ".pdf";
				}
				link.click();
			});
		},
		getProductName: function () {
			return this.calculatorConfiguration.name;
		}
	}
}
</script>
